<template>
 
  <Navbar />
  <router-view />
  <Footer />
</template>

<script>

import Navbar from './components/Navbar'
import Footer from './components/Footer'
import { dataPromise } from '@/stores/store.js';
export default {
  name: 'App',
   components:{
    Navbar,
    Footer
  },
data(){
    return {
        services:[],
       
        success: false,
        error: false,
        loading: false
      }
    },
   async mounted () {
console.log('appealive')
dataPromise.then(data => {
  // console.log(data);
  this.services = data
});
     },
}
  
</script>

<style lang="scss">
@import './assets/app.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';
// @import './assets/app.scss';
</style>
